import React from 'react';
import { awsDriverFileURL } from '../../../contexts/utils';

export const DriversStatsListCon = ({ driver, openDriverInfoModal }) => {
  const openModal = (e, child) => {
    if (child) return openDriverInfoModal(e.target.parentElement.id);

    return openDriverInfoModal(e.target.id);
  };
  return (
    <div
      className='stats-list-body-con driver'
      style={{ cursor: 'pointer' }}
      id={driver.carId}
      onClick={openModal}
    >
      <div className='with-avatar'>
        <div className='avatar'>
          <img
            src={`${awsDriverFileURL}${driver.image}`}
            alt={`${driver.name} img`}
          />
        </div>
        <div className='username'>
          <p>{driver.name}</p>
        </div>
      </div>
      <p>{driver.completedRides}</p>
      <p>{driver.carName}</p>
      <p>
        {driver.stars?.starReceived}/{driver.stars?.overall}
      </p>
      <p
        className={driver.status === 'pending' ? 'link_text' : 'def'}
        onClick={driver.status === 'pending' ? (e) => openModal(e, true) : null}
      >
        {driver.status?.substr(0, 1).toUpperCase() + driver.status?.substr(1)}
      </p>
    </div>
  );
};
